import { render } from "./CreateFolderModal.vue?vue&type=template&id=24899f16&scoped=true"
import script from "./CreateFolderModal.vue?vue&type=script&lang=js"
export * from "./CreateFolderModal.vue?vue&type=script&lang=js"

import "./CreateFolderModal.vue?vue&type=style&index=0&id=24899f16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24899f16"]])

export default __exports__